export default "__VITE_ASSET__EsBHZ4Ar__"